// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"144":"9de2fb2f","165":"3a53e7bf","328":"2906236d","453":"0b7b1b84","519":"23e92b44","796":"854a44ba"}[chunkId] + ".chunk.js";
};